import find from 'lodash/find'

export const findIdByPrefixUrl = (urls, prefix) => find(urls, (uri) => uri.startsWith(prefix))

export const findIdByArrayMatch = (urls, matchArr) =>
  find(urls, (uri) => {
    const split = uri.split('/').filter(Boolean)

    const result = matchArr.map((matchToken, index) => {
      if (index + 1 > split.length) {
        return false
      }

      if (matchToken === '*') {
        return true
      }

      return matchToken.toString() === split[index]
    })

    return result.every(Boolean)
  })
